import { LARGE_SCREEN } from '../../consts';

$(() => {
  const body = $('body');
  const button = $('#sidebar-button');
  const chevron = $('#sidebar-button span');
  const sidebar = $('#sidebar');
  const sidebarContent = $('#sidebar-content');
  const propertyDetailsRightColumn = $('#property-details #auction-details');
  const surveyorCard = $('#contact-us-container .surveyor-card');
  const secondsToClosing = parseInt($('input#_seconds-to-closing').val());
  const isAuction = $('input#_is-auction').val().toLowerCase() === 'true';
  const secondsToAuctionStart = parseInt(
    $('input#_seconds-to-auction-start').val()
  );
  const isSidebarHidden = $('input#_show-side-bar').val() === 'False';
  const isBiddingOpened = secondsToAuctionStart <= 0 && secondsToClosing >= 0;
  const isBiddingEnded = secondsToAuctionStart <= 0 && secondsToClosing <= 0;
  const shouldOpenSidebar =
    (isBiddingEnded || isBiddingOpened) && !isSidebarHidden;

  /**
   * Toggle styles on body element when sidebar is opened/closed;
   * For mobile/tablet changes body positioning to prevent scrolling beneath sidebar;
   */
  const toggleBodyPositioning = () => {
    body.toggleClass('auction-sidebar-open');
    if (window.innerHeight < LARGE_SCREEN) {
      // disable scrolling of body when sidebar is opened on mobile and preserve body position
      if (body.hasClass('auction-sidebar-open')) {
        // for mobiles and tablet, when .auction-sidebar-open is applied it sets position to fixed
        // to prevent scrolling under the sidebar, top value is set to prevent page position being
        // moved to top
        body.css({ top: `-${window.scrollY}px` });
      } else {
        // when sidebar is closed, top property is being reset, and window is scrolled to the
        // position from where sidebar was opened
        const scrollY = body.css('top');
        body.css({ top: '' });
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
  };

  const toggleSidebarState = (e) => {
    button.toggleClass('active');
    sidebar.toggleClass('hidden');
    chevron.toggleClass('active');
    sidebarContent.toggleClass('active');
    toggleBodyPositioning();

    // Toggle elements that sidebar covers
    surveyorCard.toggle();
    propertyDetailsRightColumn.toggle();

    if (!button.hasClass('active')) {
      setTimeout(() => $('.map-element').show(), 500);
    }
  };

  button.on('click', toggleSidebarState);

  // landing on property page, open sidebar if bidding for property is active or ended
  if (shouldOpenSidebar && isAuction) {
    toggleSidebarState();
  }

  const setSidebarPosition = () => {
    if (window.innerWidth < LARGE_SCREEN) {
      // for mobiles and tablet, reset those values as mobile sidebars takes full screen
      sidebar.css({
        top: '',
        height: '',
      });
    } else {
      // for desktop, based on scroll position, calculate and set sidebar height and position
      const headerHeight = $('#navigation').height();
      const scroll = $(window).scrollTop();
      const distance = headerHeight - scroll;
      const value = distance > 0 ? distance : 0;
      sidebar.css({
        top: `${value}px`,
        height: `calc(100% - ${value}px)`,
      });
    }
  };

  // set initial position
  setSidebarPosition();
  $(window).on('scroll', setSidebarPosition);
  $(window).on('resize', setSidebarPosition);
});
